import React, { useCallback } from 'react'
import cx from 'classnames'

import { formatPrice } from 'helpers'
import { Notification, type NotificationProps } from 'components/feedback'
import { Text } from 'components/dataDisplay'

import ProductImage from 'compositions/ProductImage/ProductImage'

import messages from './messages'
import s from './GiftWithSpendThresholdNotification.scss'


export type GiftWithSpendThresholdNotificationProps = NotificationProps & {
  image: string
  name: string
  staticMode?: boolean
  threshold: number
}

const GiftWithSpendThresholdNotification: React.FC<GiftWithSpendThresholdNotificationProps> = (props) => {
  const { closeNotification, image, name, onClose, staticMode, threshold } = props

  return (
    <Notification
      className={s.notification}
      closeNotification={closeNotification}
      timeout={staticMode ? null : undefined}
      withAnimation={!staticMode}
      onClose={onClose}
    >
      <div className="flex">
        <ProductImage
          className={cx('flex-none', s.image)}
          bgColor="light-beige"
          src={image}
        />
        <div className="flex items-center">
          <Text
            message={{
              ...messages.offer,
              values: {
                name,
                price: formatPrice(threshold, { removeZeroCents: true }),
              },
            }}
            style="sh6"
            html
          />
        </div>
      </div>
    </Notification>
  )
}

export default React.memo(GiftWithSpendThresholdNotification)
